var map = {
	"./ar-sa.json": 11821,
	"./en-us.json": 31813,
	"./en.json": 44174,
	"./es.json": 46725,
	"./ja.json": 87980,
	"./km.json": 60089,
	"./ko.json": 19423,
	"./mn.json": 2982,
	"./ms-en.json": 35159,
	"./ms.json": 24525,
	"./my.json": 7243,
	"./ru.json": 74600,
	"./th.json": 67549,
	"./vi.json": 91496,
	"./zh-cn.json": 22651
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 81266;